import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { useTranslation } from 'react-i18next';
// Lightweight imperative-style confirm hook: const confirm = useConfirm(); await confirm(...).
export function useConfirm() {
    const { t } = useTranslation();
    const [state, setState] = useState(null);
    const confirm = useCallback((opts) => new Promise((resolve) => setState({ ...opts, resolve })), []);
    const close = (v) => {
        state?.resolve(v);
        setState(null);
    };
    const node = (_jsx(Modal, { open: !!state, onClose: () => close(false), title: state?.title ?? t('common.confirm'), size: "sm", footer: _jsxs(_Fragment, { children: [_jsx(Button, { variant: "secondary", onClick: () => close(false), children: state?.cancelLabel ?? t('common.cancel') }), _jsx(Button, { variant: state?.danger ? 'danger' : 'primary', onClick: () => close(true), children: state?.confirmLabel ?? t('common.confirm') })] }), children: _jsx("p", { className: "text-sm text-gray-700 dark:text-gray-300", children: state?.message }) }));
    return { confirm, node };
}
